import { Model } from 'pinia-orm';
import { BelongsTo, HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import MonthlyScopeGapForecast from './MonthlyScopeGapForecast';
import Package from './Package';
import ScopeGapCategory from './ScopeGapCategory';
/* --- user header --- */
/* --- end user header --- */

export default class ScopeGapItem extends Model {
  static entity = 'App\\Models\\ScopeGapItem';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare package_id: number;
  @Num(undefined)
  declare scope_gap_category_id: number | null;
  @Str('')
  declare description: string;
  @Num(0)
  declare final_amount: number | null;
  @Str('')
  declare created_at: string;
  @Str('')
  declare updated_at: string;
  // relations
  @BelongsTo(() => Package, 'package_id', 'id')
  declare package: Package;
  @BelongsTo(() => ScopeGapCategory, 'scope_gap_category_id', 'id')
  declare scope_gap_category: ScopeGapCategory;
  @HasMany(() => MonthlyScopeGapForecast, 'scope_gap_item_id', 'id')
  declare monthly_forecasts: MonthlyScopeGapForecast[];
  /* --- user code --- */

  public forecastPercent(amount: number): number {
    return (amount / this.final_amount) * 100;
  }

  /* --- end user code --- */
}
